import { render, staticRenderFns } from "./View14.vue?vue&type=template&id=c9b9724c"
import script from "./View14.vue?vue&type=script&lang=js"
export * from "./View14.vue?vue&type=script&lang=js"
import style0 from "./View14.vue?vue&type=style&index=0&id=c9b9724c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports